/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import UserPage, { type IUserPageAttrs } from 'flarum/forum/components/UserPage';
import type { PaginatedListParams } from 'flarum/common/states/PaginatedListState';
import type User from 'flarum/common/models/User';
import type Mithril from 'mithril';
import BookshelvesListState from '../states/BookshelvesListState';
import BookshelvesList from './BookshelvesList';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

export interface BookshelvesUserPageAttrs extends IUserPageAttrs {}

export default class BookshelvesUserPage<CustomAttrs extends BookshelvesUserPageAttrs = BookshelvesUserPageAttrs> extends UserPage<
	CustomAttrs,
	BookshelvesListState | null
> {
	oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
		super.oninit(vnode);

		const routeUsername = m.route.param('username');
		this.state = null;
		this.loadUser(routeUsername);
	}

	show(user: User) {
		this.user = user;
		app.current.set('user', user);
		app.setTitle(user.displayName());

		this.state = new BookshelvesListState(this.requestParams);
		this.state.refresh();

		m.redraw();
	}

	content(): Mithril.Children {
		if (!this.state) return <LoadingIndicator />;

		return (
			<div className="BookshelvesUserPage">
				<BookshelvesList state={this.state} />
			</div>
		);
	}

	get requestParams(): PaginatedListParams {
		return {
			filter: {
				user: this.user?.id(),
			},
			sort: m.route.param('sort'),
		};
	}
}
